import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Nav, NavItem, Card } from "react-bootstrap";
import "./SideNavigation.css";

export default function SideNavigationMenu(props) {
  const activeStyle = { 
    backgroundColor: "#005867", 
    color: "white",
    borderRadius: "4px"
  };
  
  return (
    <div className="side-nav-container">
      {/* Main Header Stripe */}
      <div className="side-nav-main-header">
        <h4 className="main-header-title">Allowances</h4>
      </div>
      
      {/* Main Navigation Section - without header */}
      <Card className="side-nav-card mb-3 mt-3">
        <Card.Body className="p-2">
          <Nav className="flex-column">
            <NavItem className="nav-item">
              <NavLink to="/travel/myvouchers" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                My Allowances
              </NavLink>
            </NavItem>
            <NavItem className="nav-item">
              <NavLink to="/travel/faq" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                FAQ
              </NavLink>
            </NavItem>
          </Nav>
        </Card.Body>
      </Card>

      {/* Management Section */}
      {props.isManager && (
        <Card className="side-nav-card mb-3">
          <Card.Body className="p-0">
            <div className="side-nav-section">
              <h5 className="side-nav-section-title">Management</h5>
            </div>
            <Nav className="flex-column px-2 py-2">
              <NavItem className="nav-item">
                <NavLink to="/travel/manager/dashboard" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                  Team Allowances
                </NavLink>
              </NavItem>
              <NavItem className="nav-item">
                <NavLink to="/travel/manager/employee" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                  Employee Allowances
                </NavLink>
              </NavItem>
            </Nav>
          </Card.Body>
        </Card>
      )}
      
      {/* Administration Section */}
      {props.isAdmin && (
        <Card className="side-nav-card mb-3">
          <Card.Body className="p-0">
            <div className="side-nav-section">
              <h5 className="side-nav-section-title">Administration</h5>
            </div>
            <Nav className="flex-column px-2 py-2">
              <NavItem className="nav-item">
                <NavLink to="/travel/employees" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                  Employees
                </NavLink>
              </NavItem>
              <NavItem className="nav-item">
                <NavLink to="/travel/vouchergroups" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                  Allowances
                </NavLink>
              </NavItem>
              <NavItem className="nav-item">
                <NavLink to="/travel/onetime-expense" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                  One-Time Expense
                </NavLink>
              </NavItem>
            </Nav>
          </Card.Body>
        </Card>
      )}
    </div>
  );
}

SideNavigationMenu.propTypes = {
  isAdmin: PropTypes.bool,
  isManager: PropTypes.bool,
};